// src/services/sesService.js

import {
  SESClient,
  GetSendStatisticsCommand,
  SendEmailCommand,
  GetSendQuotaCommand,
} from '@aws-sdk/client-ses';

const getSESClient = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  if (!user || !user.awsAccessKey || !user.awsSecretKey || !user.region) {
    throw new Error("AWS credentials not found.");
  }
  return new SESClient({
    region: user.region,
    credentials: {
      accessKeyId: user.awsAccessKey,
      secretAccessKey: user.awsSecretKey,
    },
    maxAttempts: 5, // Increase the number of retry attempts
  });
};

const sesService = {
  getStatistics: async () => {
    const client = getSESClient();
    const command = new GetSendStatisticsCommand({});
    const response = await client.send(command);
    return response;
  },

  getDailyUsage: async () => {
    const client = getSESClient();
    const command = new GetSendQuotaCommand({});
    const response = await client.send(command);

    const max24HourSend = response.Max24HourSend;
    const sentLast24Hours = response.SentLast24Hours;
    const usedPercent = max24HourSend
      ? ((sentLast24Hours / max24HourSend) * 100).toFixed(2)
      : 0;

    return {
      sent: sentLast24Hours,
      remaining: max24HourSend - sentLast24Hours,
      usedPercent,
    };
  },

  sendTestEmail: async (template, testEmail) => {
    const client = getSESClient();
    const params = {
      Source: "information@homegrown-genetics.com", // Ensure this email is verified in SES
      Destination: {
        ToAddresses: [testEmail],
      },
      Message: {
        Subject: { Data: template.subject || "Test Email" },
        Body: {
          Html: { Data: template.htmlContent || "<p>No content provided.</p>" },
        },
      },
    };

    const command = new SendEmailCommand(params);
    return client.send(command);
  },
};

export default sesService;
